module.exports = __webpack_public_path__ + "static/atlaskit-breadcrumb-large-7bd017fbc0839982db8c765fd87a9aa2.png";